import HOST_API from 'constants/HOST_API';

import React from 'react';
import Recoil from 'recoil';
import CryptoJS from 'crypto-js';
import useFetch from './useFetch';
import { luxonNow } from 'utils/time';
import { decrypt_password, encrypt_password } from 'utils/crypto';

export default function useDoctorLogin(props) {
  const onRequest = useFetch(HOST_API, 'V100/doctors/login');

  const requestDoctorLogin = React.useCallback((parameters, callback) => {
    const {
      dr_id,
      password,
    } = parameters;

    if (!dr_id) return;

    const onReceive = (res) => {
      if (+res.res_code === 200) {
        callback && callback(true, res.data, parameters);
      } else {
        callback && callback(false, { message: res?.res_msg }, parameters);
      }
    };
    const onCatch = (err) => {
      callback && callback(false, { message: '서버에 연결할 수 없습니다.' }, parameters);
    };
    const onExpire = (abort) => {
      abort('Timeout');
      callback && callback(false, { message: '서버가 응답하지 않습니다.' }, parameters);
      return true;
    };

    const time = luxonNow().toFormat('yyyyMMddHHmmss');
    const sha256 = CryptoJS.SHA256(password).toString().toUpperCase();
    const encrypted = encrypt_password(sha256, time);

    onRequest({
      parameters: {
        dr_id,
        password: encrypted,
        time,
      },
      timeout: 6000,
      events: {
        onReceive,
        onExpire,
        onCatch,
      }
    });
  }, [onRequest]);

  const onDoctorLogin = React.useCallback((callback) => (parameters) => {
    requestDoctorLogin({ ...parameters }, callback);
  }, [requestDoctorLogin]);

  return {
    requestDoctorLogin,
    onDoctorLogin,
  };
}
